import React from 'react';
import { Box, Typography } from '@mui/material';

/** Tenant Hub mark — interlocking hubs / multi-tenant glyph */
const TenantHubLogo = ({ size = 40, gradient = 'linear-gradient(135deg, #f59e0b 0%, #ef4444 100%)', showWordmark = false }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: '12px',
        background: gradient,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: '0 4px 14px rgba(0,0,0,0.25)',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      <svg width={size * 0.62} height={size * 0.62} viewBox="0 0 48 48" fill="none" aria-hidden>
        <rect x="6" y="6" width="16" height="16" rx="4" fill="white" fillOpacity="0.95" />
        <rect x="26" y="6" width="16" height="16" rx="4" fill="white" fillOpacity="0.7" />
        <rect x="6" y="26" width="16" height="16" rx="4" fill="white" fillOpacity="0.7" />
        <rect x="26" y="26" width="16" height="16" rx="4" fill="white" fillOpacity="0.45" />
        <circle cx="24" cy="24" r="5" fill="white" />
      </svg>
    </Box>
    {showWordmark && (
      <Box>
        <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.02em' }}>
          Tenant Hub
        </Typography>
      </Box>
    )}
  </Box>
);

export default TenantHubLogo;
